import type {LiteralUnion} from './common'

export enum MemberStatusVersion {
    NOT_EXIST = '1.0',
    AUTO_DEPOSIT_PENDING = '2.0',
    TERMINATED = '3.0',
    NORMAL = '4.0',
    SUSPENDED_ACCOUNT = '4.1',
    ACCOUNT_UNREGISTERED = '4.2',
}

/**
 * @description 페이머니 제휴 은행 타입 (= 은행 코드)
 */
export const MEMBER_TYPE = {
    HANABANK: '081',
}

export const DERIVATIVES = {
    CHECK_CARD: {
        HANA_GREEN: '13502',
        HANA_WHITE: '14032',
    },
}

export const RESERVATION_CHARGE_STATUS = {
    ACTIVE: 'A', // 사용 중
    STOP: 'S', // 정지
    ERROR: 'X', // 결제수단의 문제로 사용불가, 계좌삭제
    DELETE: 'D', // 만료/삭제
} as const

export const RESERVATION_CHARGE_TYPE = {
    UNDER: 'U', // 지정 금액 이하 충전
    DAY: 'D', // 지정일 충전
    DIFFERENCE: 'F', // 차액 충전
} as const

const PREFERENTIAL_LIMIT_AMOUNT = 2000000
export const PREFERENTIAL_LIMIT = {
    AMOUNT: PREFERENTIAL_LIMIT_AMOUNT,
    AMOUNT_TEXT: `${PREFERENTIAL_LIMIT_AMOUNT / 10000}만원`,
}

export interface PayMoneyCoin {
    requestUuid: string
    rtncd: number
    rtnmsg: string
    response: {
        chnl: string
        userkey: string
        nidno: string
        name: string
        cointype: LiteralUnion<'06' | '33', string> // 페이머니: 06, 페이머니 하나통장: 33
        memberType: string
        totalAmt: number
        amt1: number
        amt2: number
        amt3: number
        amt4: number
    }
}
